import { db } from '@/db/client';
import { PlayerGroupSchema, type PlayerGroup } from '@/schemas';

export interface MergePlayerGroupsResult {
  applied: number;
  replaced: number;
}

function shouldReplacePlayerGroup(existing: PlayerGroup, incoming: PlayerGroup): boolean {
  if (incoming.updatedAt !== existing.updatedAt) {
    return incoming.updatedAt > existing.updatedAt;
  }
  if (incoming.createdAt !== existing.createdAt) {
    return incoming.createdAt > existing.createdAt;
  }
  return incoming.id > existing.id;
}

export async function mergeRemotePlayerGroups(
  incoming: PlayerGroup[],
): Promise<MergePlayerGroupsResult> {
  if (incoming.length === 0) return { applied: 0, replaced: 0 };

  const validated = incoming.map((group) => PlayerGroupSchema.parse(group));
  let applied = 0;
  let replaced = 0;

  await db.transaction('rw', db.playerGroups, async () => {
    for (const group of validated) {
      const existing = await db.playerGroups.get(group.id);
      if (existing) {
        if (shouldReplacePlayerGroup(existing, group)) {
          await db.playerGroups.put(group);
          replaced += 1;
        }
      } else {
        await db.playerGroups.add(group);
        applied += 1;
      }
    }
  });

  return { applied, replaced };
}
